/**
 * Accepts an array of items to be filtered via a search query string and additional search filters. Items are
 * returned as is if the query is an empty string. Search query string will be passed onto filter functions
 * and only one filter has to return true has to return true in order to pass the overarching filter.
 */
export default function filterItemsToSearchQuery<T>(
  items: Array<T>,
  searchQuery: string,
  searchFilters: Array<(item: T, searchQuery: string) => boolean>
): Array<T> {
  if (searchQuery === '') {
    return items;
  }
  return items.filter((item) => searchFilters.some((filter) => filter(item, searchQuery)));
}
